<template>
  <div class="column is-9">
    <div v-if="isLoading" class="loading">
      <pulse-loader :loading="isLoading"></pulse-loader>
    </div>
    <div
      v-else-if="page && pageContent && !isLoading"
      class="is-border is-radius-large has-bg-white content content-guide"
    >
      <div class="column is-border-bottom">
        <h1 class="title" v-html="pageTitle"></h1>
        <!-- <a class="editBtn" :href="cmsPath+'/wp-admin/post.php?post='+page.data.ID+'&action=edit'" target="_blank">edit page</a> -->
        <span class="intro-guide-faq" v-html="pageContent"></span>
        <div v-if="pageIllustration" class="media" style="text-align:center">
          <img :src="pageIllustration.url" style="text-align :center" alt="Vadimm - FAQ : accueil">
        </div>
      </div>
      <!--
      <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
        <topic-tile :key="topic.id" :topic="topic" v-for="topic in authorizedTopics"></topic-tile>
      </ul>
      -->
      <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
        <topic-tile
          v-for="child in page.data.childs" :key="child.slug" :topic="child"
        >
        </topic-tile>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { api } from '../cmsApi'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import TopicTile from '../components/TopicTile'
  // import PageTile from '../components/PageTile'

  // const PrismicDOM = require('prismic-dom')

  export default {
    name: 'Home',
    components: {
      TopicTile,
      //PageTile,
      PulseLoader
    },
    computed: {
      // ...mapGetters(['authorizedTopics'])
    },
    data () {
      return {
        isLoading: false,
        page: null,
        pageTitle: null,
        pageContent: null,
        pageIllustration: null,
        cmsPath: process.env.VUE_APP_CMS,
      }
    },
    created () {
      this.initComponent()
    },
    methods: {
      async initComponent () {
        this.isLoading = true
        // let page = (await api.fetchContents('homepage'))[0]
        let page = await api.fetchPage('accueil')
        this.page = page
        this.pageTitle = page.data.title
        this.pageContent = page.data.content
        this.pageIllustration = page.data.cover
        this.isLoading = false
      }
    }
  }
</script>


<style lang="css" scoped>

  a.editBtn{ position:absolute;right:40px;top:30px; }

  .fade-enter-active, .fade-leave-active {
      transition: opacity .3s, transform .3s;
      transform: translateX(0px);
  }
  .fade-enter{
      opacity: 0;
      transform: translateX(-20px);
  }
  .fade-leave-to{
      opacity: 0;
      transform: translateX(40px);
  }

</style>

